<template>
  <div class="app-container">
    <CrudTable entity="User" :columns="columns" :requires-domain-id="true" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['code', 'name']
    };
  }
};
</script>

<style scoped></style>
